angular.module('app').directive('apFooter', [
        'BrowserService',
        'ConsentRepository',
        'aprgettext',
        'ViewDocumentModal',
        function (
            BrowserService,
            ConsentRepository,
            gettext,
            ViewDocumentModal
            ) {
            'use strict';
            return {
                restrict: 'E',
                templateUrl: '/app/partials/footer/views/apFooter.html',
                scope: true,
                transclude: false,
                link: function (scope) {

                    scope.apFooter = {
                        //PatientAuthenticated: SessionService.getPatientAuthenticated()
                    };

                    function viewPrivacyPolicyImage() {
                        scope.isModalDisplayed = true;

                        var modalConfig = {
                            Title: gettext('Privacy Policy'),
                            DocumentId: 'privacypolicy',
                            DocumentLoad: getPrivacyPolicyImage,
                            DocumentDownload: downloadPrivacyPolicy,
                            DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                        };


                        function getPrivacyPolicyImage(documentId, requestSettings) {
                            return ConsentRepository.getAgreementPrivacyPolicyImage(requestSettings);
                        }

                        function downloadPrivacyPolicy(){
                            return ConsentRepository.downloadAgreementPrivacyPolicy()
                                .then(function (data) {
                                    return {Data: data.Data, FileName: 'PrivacyPolicy', Extension: 'pdf'};
                                })
                                .catch(function (response) {
                                    scope.addHttpError(response);
                                })
                                .finally(function() {
                                });
                        }

                        ViewDocumentModal.openViewDocumentModal(modalConfig);
                    }

                    scope.viewPrivacyPolicyImage = viewPrivacyPolicyImage;

                    scope.$on('$destroy', function () {
                    });

                }
            };
        }
    ]
);